import { render, staticRenderFns } from "./CommissionDashboard.vue?vue&type=template&id=3b007362&"
import script from "./CommissionDashboard.vue?vue&type=script&lang=js&"
export * from "./CommissionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports